"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const personas = [{
  title: "Deep Tissue Therapy",
  description: "Designed to release chronic muscle tension and promote recovery, our deep tissue therapy targets the inner layers of your muscles and connective tissues for lasting relief.",
  action: "Learn More",
  link: "https://nataliasbeauty.com/beauty-treatments-norwich/"
}, {
  title: "Aromatherapy Ritual",
  description: "A sensory journey using bespoke essential oil blends and gentle rhythmic strokes to balance your mind, body, and spirit in a state of complete, high-end tranquility.",
  action: "Learn More",
  link: "https://nataliasbeauty.com/beauty-treatments-norwich/"
}, {
  title: "Hot Stone Serenity",
  description: "Experience the profound warmth of volcanic stones as they melt away stress and improve circulation, leaving you in a state of pure, weightless bliss and total relaxation.",
  action: "Learn More",
  link: "https://nataliasbeauty.com/beauty-treatments-norwich/"
}];
export default function WhoHerSphereIsFor() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="183937" id="massagetypes" className="relative overflow-hidden bg-background py-[160px] text-foreground">
      {}
      <div className="absolute top-0 left-1/4 -z-10 h-[40rem] w-[40rem] -translate-y-1/2 rounded-lg bg-primary/10 blur-[120px]" />
      <div className="absolute right-1/4 bottom-0 -z-10 h-[30rem] w-[30rem] translate-y-1/2 rounded-lg bg-secondary/20 blur-[100px]" />

      <div ref={ref} className={`container mx-auto max-w-7xl px-6 transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
        <div className="mb-24 flex flex-col items-center text-center">
          <h2 className="mb-8 font-serif text-4xl tracking-tight text-foreground md:text-5xl lg:text-6xl">
            Curated Massage Rituals
          </h2>
          <div className="h-[1px] w-24 bg-primary/30" />
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-12 lg:gap-10">
          {personas.map((persona, i) => <div key={i} data-index={i} className="flex md:col-span-4">
              <Card className="flex w-full flex-col border-none rounded-3xl bg-card/40 shadow-sm backdrop-blur-xl transition-all duration-700 hover:-translate-y-3 hover:shadow-xl">
                <CardHeader className="px-8 pb-6 pt-12">
                  <CardTitle className="font-serif text-2xl tracking-wide text-foreground/90">
                    {persona.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="flex-grow px-8">
                  <p className="font-sans text-sm font-light leading-relaxed text-muted-foreground/80">
                    {persona.description}
                  </p>
                </CardContent>
                <CardFooter className="px-8 pb-12 pt-6">
                  <Button asChild variant="ghost" className="group h-12 w-full justify-between rounded-lg border-none bg-primary/10 px-6 transition-all duration-500 hover:bg-primary/30 hover:text-foreground">
                    <Link to={persona.link} newTab={true}>
                      <span className="text-xs font-medium uppercase tracking-widest">
                        {persona.action}
                      </span>
                      <ArrowRight className="h-4 w-4 opacity-40 transition-all duration-300 group-hover:translate-x-1 group-hover:opacity-100" />
                    </Link>
                  </Button>
                </CardFooter>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}